<template>

    <two-factor-login-flow
        :title="$t('two_factor_suggested.title')"
        :subtitle="$t('two_factor_suggested.subtitle')"
        :introBold="$t('two_factor_suggested.intro_bold')"
        :intro="$t('two_factor_suggested.intro')"
        :introButton="$t('two_factor_suggested.intro_button')"
        :footer="$t('two_factor_suggested.footer')"
        :verifyStep1="$t('two_factor_config.step_1')"
        :verifyStep2="$t('two_factor_config.step_2')"
        :verifyStep3="$t('two_factor_config.step_3')" />

</template>

<script>
import TwoFactorLoginFlow from './TwoFactorLoginFlow.vue';

export default {
    components: {
        'two-factor-login-flow': TwoFactorLoginFlow
    },
    methods: {
        suggested() {
            axios.post(route('app.suggest-2fa'));
        },
    },
    mounted() {
        this.suggested();
    },
}
</script>
